if (!window.dAgency) window.dAgency = {};

window.dAgency.initAccordions = () => {
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion-content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.openedEvent = new Event('accordionOpenedEvent');
      this.closedEvent = new Event('accordionClosedEvent');
      if (!this.el.dataset.index) {
        this.el.dataset.index = new Date().getTime();
      }
      this.dataIndex = this.el.dataset.index;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      document.querySelectorAll('details summary').forEach(accordionOpener => {
        accordionOpener.style.pointerEvents = 'none';
      });
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
      setTimeout(() => {
        document.querySelectorAll('details summary').forEach(accordionOpener => {
          accordionOpener.style.pointerEvents = '';
        });
      }, 900);
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 800,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
      if (this.el.classList.contains('filter__disclosure')) {
        $('details.filter__disclosure[open]:not([data-index="' + this.dataIndex + '"]) summary').trigger('click');
      }
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';

      if (this.el.open) {
        this.el.dispatchEvent(this.openedEvent);
      } else {
        this.el.dispatchEvent(this.closedEvent);
      }
    }
  }

  document.querySelectorAll('details').forEach((el) => {
    if (el.querySelector('summary') && el.querySelector('.accordion-content')) {
      new Accordion(el);
    }
  });
}

window.dAgency.initAccordions();
